import "assets/css/dashboard.css"
import "assets/css/terminals.css"
import { useEffect, useState } from "react"
import { fetchSummaryData } from "components/Dashboard/helpers"
import InventoryReport from "components/Dashboard/InventoryReport"
import Summary from "components/Dashboard/Summary"
import LineChart from "components/Dashboard/LineChart"
import HeatmapChart from "components/Dashboard/ordersHeatMap"
import CrossBorderTime from "components/Dashboard/CrossBorderTime"
import { CardFrame } from "components/UI/CardFrame"

const Dashboard = () => {
  const [summaryData, setSummaryData] = useState({})
  const inventoryReport = summaryData.inventory_report
  const terminalSummary = summaryData.summary

  useEffect(() => {
    let isMounted = true

    const loadSummary = async () => {
      try {
        if (isMounted) {
          await fetchSummaryData(setSummaryData)
        }
      } catch {
        if (isMounted) {
          setSummaryData({})
        }
      }
    }

    loadSummary()

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <div className="main-container">
      {/* Inventory summary table */}
      {inventoryReport && (
        <CardFrame title="Warehouse KPIs">
          <InventoryReport data={inventoryReport} />
        </CardFrame>
      )}
      {/* Per terminal buses and partials */}
      {terminalSummary && <Summary data={terminalSummary} />}
      <div className="row">
        {/* Orders overview */}
        <div className="col-lg-12 col-md-12">
          <CardFrame title="Lane Order Traffic - By Pickup Date">
            <div className="p-0 m-0 pt-4" style={{ height: "654px" }}>
              <LineChart />
            </div>
          </CardFrame>
        </div>
        {/* Scheduled pickup heatmap */}
        <div className="col-lg-6 col-md-12">
          <HeatmapChart />
        </div>
        <div className="col-lg-6 col-md-12">
          <CrossBorderTime />
        </div>
      </div>
    </div>
  )
}

export default Dashboard
